module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "flexbetween"
  }, [((_vm.isAu() && !_vm.isAuPremiumAppVer) || _vm.isSoftbank()) ? _c('div', {
    staticClass: "navigation menu-bar"
  }) : _c('div', {
    staticClass: "navigation menu-bar"
  }, [_c('popover', {
    attrs: {
      "name": "navigation-left",
      "closeOnContentClick": true
    }
  }, [_c('div', {
    staticClass: "btn-menu-bar",
    attrs: {
      "slot": "face"
    },
    slot: "face"
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/header/logo-s.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navigation-left-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', [(_vm.showDictionary) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.goDictionary()
      }
    }
  }, [_vm._v("辞書")]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.goLibrary()
      }
    }
  }, [_vm._v("ライブラリへ戻る")])])])])], 1), _vm._v(" "), (_vm.isCurrentViewHome) ? _c('div', {
    staticClass: "contentname lbold sp-top"
  }, [_vm._v(_vm._s(_vm.contentName))]) : (_vm.isEnvironmentPc()) ? _c('div', {
    staticClass: "contentname lbold"
  }, [_vm._v(_vm._s(_vm.contentName) + " : レッスン " + _vm._s(_vm.lessonIndex + 1) + " " + _vm._s(_vm.pathTitle))]) : _c('div', {
    staticClass: "contentname lbold"
  }, [_vm._v(_vm._s(_vm.contentName)), _c('br'), _vm._v("レッスン " + _vm._s(_vm.lessonIndex + 1) + " " + _vm._s(_vm.pathTitle))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCurrentViewHome),
      expression: "!isCurrentViewHome"
    }],
    staticClass: "sp-second-header"
  }, [_c('div', {
    staticClass: "items flexcenter"
  }, [_c('div', {
    staticClass: "progress font18"
  }, [(_vm.isMilestone) ? _c('div', [_c('span', {
    staticClass: "textred"
  }, [_vm._v(_vm._s(_vm.milestoneGroupIndex))]), _vm._v(" / " + _vm._s(_vm.milestoneGroupLength))]) : _c('div', [_c('span', {
    staticClass: "textred"
  }, [_vm._v(_vm._s(_vm.pathstepIndex + 1))]), _vm._v(" / " + _vm._s(_vm.pathstepLength))])]), _vm._v(" "), _c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDisplayMode),
      expression: "showDisplayMode"
    }],
    staticClass: "setting-lang"
  }, [(_vm.productInfo.language == _vm.constants.LANGUAGE_CODE_ZHCV && _vm.isScriptTypeKan) ? _c('popover', {
    attrs: {
      "name": "answer",
      "closeOnContentClick": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "face"
    },
    slot: "face"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMode == _vm.constants.DISPLAY_MODE_WITH_PINYIN),
      expression: "displayMode == constants.DISPLAY_MODE_WITH_PINYIN"
    }],
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/han-and-pinin.png"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMode == _vm.constants.DISPLAY_MODE_NO_PINYIN),
      expression: "displayMode == constants.DISPLAY_MODE_NO_PINYIN"
    }],
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/han.png"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMode == _vm.constants.DISPLAY_MODE_PINYIN_ONLY),
      expression: "displayMode == constants.DISPLAY_MODE_PINYIN_ONLY"
    }],
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/han-pinin.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lang-status",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.displayMode == _vm.constants.DISPLAY_MODE_WITH_PINYIN
    },
    on: {
      "click": function($event) {
        return _vm.setDisplayMode(_vm.constants.DISPLAY_MODE_WITH_PINYIN)
      }
    }
  }, [_vm._v("\n                        簡体字（ピンイン付き）\n                      ")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.displayMode == _vm.constants.DISPLAY_MODE_NO_PINYIN
    },
    on: {
      "click": function($event) {
        return _vm.setDisplayMode(_vm.constants.DISPLAY_MODE_NO_PINYIN)
      }
    }
  }, [_vm._v("\n                        簡体字のみ\n                      ")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.displayMode == _vm.constants.DISPLAY_MODE_PINYIN_ONLY
    },
    on: {
      "click": function($event) {
        return _vm.setDisplayMode(_vm.constants.DISPLAY_MODE_PINYIN_ONLY)
      }
    }
  }, [_vm._v("\n                        ピンインのみ\n                      ")])])])]) : _vm._e(), _vm._v(" "), (_vm.productInfo.language == _vm.constants.LANGUAGE_CODE_ZHCV && _vm.isScriptTypeHan) ? _c('popover', {
    attrs: {
      "name": "answer",
      "closeOnContentClick": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "face"
    },
    slot: "face"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMode == _vm.constants.DISPLAY_MODE_WITH_PINYIN),
      expression: "displayMode == constants.DISPLAY_MODE_WITH_PINYIN"
    }],
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/kan-and-pinin.png"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMode == _vm.constants.DISPLAY_MODE_NO_PINYIN),
      expression: "displayMode == constants.DISPLAY_MODE_NO_PINYIN"
    }],
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/kan.png"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMode == _vm.constants.DISPLAY_MODE_PINYIN_ONLY),
      expression: "displayMode == constants.DISPLAY_MODE_PINYIN_ONLY"
    }],
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/kan-pinin.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lang-status",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.displayMode == _vm.constants.DISPLAY_MODE_WITH_PINYIN
    },
    on: {
      "click": function($event) {
        return _vm.setDisplayMode(_vm.constants.DISPLAY_MODE_WITH_PINYIN)
      }
    }
  }, [_vm._v("\n                        繁体字（ピンイン付き）\n                      ")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.displayMode == _vm.constants.DISPLAY_MODE_NO_PINYIN
    },
    on: {
      "click": function($event) {
        return _vm.setDisplayMode(_vm.constants.DISPLAY_MODE_NO_PINYIN)
      }
    }
  }, [_vm._v("\n                        繁体字のみ\n                      ")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.displayMode == _vm.constants.DISPLAY_MODE_PINYIN_ONLY
    },
    on: {
      "click": function($event) {
        return _vm.setDisplayMode(_vm.constants.DISPLAY_MODE_PINYIN_ONLY)
      }
    }
  }, [_vm._v("\n                        ピンインのみ\n                      ")])])])]) : _vm._e(), _vm._v(" "), (_vm.productInfo.language == _vm.constants.LANGUAGE_CODE_HEIL) ? _c('popover', {
    attrs: {
      "name": "answer",
      "closeOnContentClick": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "face"
    },
    slot: "face"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMode == _vm.constants.DISPLAY_MODE_UNVOWELED),
      expression: "displayMode == constants.DISPLAY_MODE_UNVOWELED"
    }],
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/he-nosign.png"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMode == _vm.constants.DISPLAY_MODE_VOWELED),
      expression: "displayMode == constants.DISPLAY_MODE_VOWELED"
    }],
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/he-sign.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lang-status",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.displayMode == _vm.constants.DISPLAY_MODE_UNVOWELED
    },
    on: {
      "click": function($event) {
        return _vm.setDisplayMode(_vm.constants.DISPLAY_MODE_UNVOWELED)
      }
    }
  }, [_vm._v("\n                        母音記号なし\n                      ")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.displayMode == _vm.constants.DISPLAY_MODE_VOWELED
    },
    on: {
      "click": function($event) {
        return _vm.setDisplayMode(_vm.constants.DISPLAY_MODE_VOWELED)
      }
    }
  }, [_vm._v("\n                        母音記号あり\n                      ")])])])]) : _vm._e(), _vm._v(" "), (_vm.productInfo.language == _vm.constants.LANGUAGE_CODE_JAJP) ? _c('popover', {
    attrs: {
      "name": "answer",
      "closeOnContentClick": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "face"
    },
    slot: "face"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMode == _vm.constants.DISPLAY_MODE_KANJI_WITH_KANA),
      expression: "displayMode == constants.DISPLAY_MODE_KANJI_WITH_KANA"
    }],
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/kan-huri.png"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMode == _vm.constants.DISPLAY_MODE_KANJI),
      expression: "displayMode == constants.DISPLAY_MODE_KANJI"
    }],
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/kan-ja.png"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMode == _vm.constants.DISPLAY_MODE_KANA),
      expression: "displayMode == constants.DISPLAY_MODE_KANA"
    }],
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/hira-kata.png"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMode == _vm.constants.DISPLAY_MODE_ROMAJI),
      expression: "displayMode == constants.DISPLAY_MODE_ROMAJI"
    }],
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/roma.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lang-status",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.displayMode == _vm.constants.DISPLAY_MODE_KANJI_WITH_KANA
    },
    on: {
      "click": function($event) {
        return _vm.setDisplayMode(_vm.constants.DISPLAY_MODE_KANJI_WITH_KANA)
      }
    }
  }, [_vm._v("\n                        漢字（ふりがな付き）\n                      ")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.displayMode == _vm.constants.DISPLAY_MODE_KANJI
    },
    on: {
      "click": function($event) {
        return _vm.setDisplayMode(_vm.constants.DISPLAY_MODE_KANJI)
      }
    }
  }, [_vm._v("\n                        漢字\n                      ")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.displayMode == _vm.constants.DISPLAY_MODE_KANA
    },
    on: {
      "click": function($event) {
        return _vm.setDisplayMode(_vm.constants.DISPLAY_MODE_KANA)
      }
    }
  }, [_vm._v("\n                        ひらがな・カタカナ\n                      ")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.displayMode == _vm.constants.DISPLAY_MODE_ROMAJI
    },
    on: {
      "click": function($event) {
        return _vm.setDisplayMode(_vm.constants.DISPLAY_MODE_ROMAJI)
      }
    }
  }, [_vm._v("\n                        ローマ字\n                      ")])])])]) : _vm._e()], 1), _vm._v(" "), (_vm.showDictionary && !_vm.isEnvironmentPc()) ? _c('div', {
    staticClass: "setting-dic",
    on: {
      "click": function($event) {
        return _vm.goDictionaryWordList()
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCurrentViewHome),
      expression: "!isCurrentViewHome"
    }],
    staticClass: "setting-lang"
  }, [(_vm.isReview) ? _c('div', {
    staticClass: "btn-lang",
    staticStyle: {
      "cursor": "default"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/lang-off.png"
    }
  })]) : _c('popover', {
    attrs: {
      "name": "answer",
      "closeOnContentClick": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "face"
    },
    slot: "face"
  }, [(_vm.isAllAnswerVisible) ? _c('div', {
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/lang-en.png"
    }
  })]) : _c('div', {
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/lang-en-t.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lang-status",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.isAllAnswerVisible
    },
    on: {
      "click": function($event) {
        return _vm.changeShowAllAnswer()
      }
    }
  }, [_vm._v("全解答を表示する")])])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCurrentViewHome),
      expression: "!isCurrentViewHome"
    }],
    staticClass: "setting-score"
  }, [(_vm.isMilestone || _vm.isReview) ? _c('div', {
    staticClass: "btn-score",
    staticStyle: {
      "cursor": "default"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/score-off.png"
    }
  })]) : _c('div', {
    staticClass: "btn-score",
    on: {
      "click": function($event) {
        return _vm.showLessonScore()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon/header/score.png"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "navigation menu-dots"
  }, [_c('popover', {
    attrs: {
      "name": "navigation-right",
      "closeOnContentClick": true
    }
  }, [_c('div', {
    staticClass: "btn-menu-dots",
    attrs: {
      "slot": "face"
    },
    on: {
      "click": function($event) {
        return _vm.updateMenu()
      }
    },
    slot: "face"
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/header/setting-dots.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navigation-right-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', [(!_vm.isCurrentViewHome) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.goHome()
      }
    }
  }, [_vm._v("ホームへ戻る")]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.showSetting()
      }
    }
  }, [_vm._v("設定")]), _vm._v(" "), (!_vm.isDocomo() && _vm.isCurrentViewHome) ? _c('li', [_c('a', {
    staticClass: "readme",
    attrs: {
      "href": _vm.tourURL,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.pauseAudio()
      }
    }
  }, [_vm._v("ツアーを開始")])]) : _vm._e(), _vm._v(" "), (_vm.isDocomo()) ? _c('li', {
    staticClass: "docomo_push"
  }, [_c('div', [_c('span', [_vm._v("プッシュ通知を許可")]), _c('span', {
    staticClass: "push_option",
    class: {
      active: _vm.isPushEnabled
    },
    on: {
      "click": function($event) {
        return _vm.showPushSetting()
      }
    }
  }, [_vm._v("ON")]), _c('span', {
    staticClass: "push_option",
    class: {
      active: !_vm.isPushEnabled
    },
    on: {
      "click": function($event) {
        return _vm.showPushSetting()
      }
    }
  }, [_vm._v("OFF")])]), _vm._v(" "), _c('div', {
    staticClass: "font14 lbold ml10 mt10"
  }, [_vm._v("月に1~3回程度アップデート案内します。")]), _vm._v(" "), _c('div', {
    staticClass: "font14 ml10"
  }, [_c('span', [_vm._v("らくらくスマートフォン等の非対応機種では配信されません。")])])]) : _vm._e(), _vm._v(" "), (_vm.isAu() || _vm.isSoftbank()) ? _c('li', {
    staticClass: "other_push"
  }, [_c('span', [_vm._v("プッシュ通知を許可")]), _c('span', {
    staticClass: "push_option",
    class: {
      active: _vm.isPushEnabled
    },
    on: {
      "click": function($event) {
        return _vm.showPushSetting()
      }
    }
  }, [_vm._v("ON")]), _c('span', {
    staticClass: "push_option",
    class: {
      active: !_vm.isPushEnabled
    },
    on: {
      "click": function($event) {
        return _vm.showPushSetting()
      }
    }
  }, [_vm._v("OFF")])]) : _vm._e(), _vm._v(" "), (!_vm.isCarrier()) ? _c('li', [_c('a', {
    staticClass: "helptext",
    attrs: {
      "href": "http://www.sourcenext.com/manual_sc/pc/rosettastone_advanced/home/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.pauseAudio()
      }
    }
  }, [_vm._v("ヘルプ")])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.clickLanguageLetterButton
    }
  }, [_vm._v("学習言語の文字一覧")]), _vm._v(" "), (!_vm.isCarrier()) ? _c('li', [_c('a', {
    staticClass: "readme",
    attrs: {
      "href": _vm.audioCompanionURL,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.pauseAudio()
      }
    }
  }, [_vm._v("Audio Companion")])]) : _vm._e(), _vm._v(" "), (!_vm.isCarrier()) ? _c('li', [_c('a', {
    staticClass: "readme",
    attrs: {
      "href": "https://www.sourcenext.com/r/p/rosettastone/eula/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.pauseAudio()
      }
    }
  }, [_vm._v("Rosetta Stone について")])]) : _vm._e(), _vm._v(" "), (_vm.isDocomo()) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.showPrivacyPolicy()
      }
    }
  }, [_vm._v("プライバシーポリシー")]) : _vm._e(), _vm._v(" "), ((_vm.isAu() && !_vm.isAuPremiumAppVer) || _vm.isSoftbank()) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.showTakeOver()
      }
    }
  }, [_vm._v("引継ぎコード発行")]) : _vm._e(), _vm._v(" "), (_vm.isSoftbank()) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.getTosUrl(),
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.pauseAudio()
      }
    }
  }, [_vm._v("利用規約")])]) : _vm._e(), _vm._v(" "), (_vm.isAu() || _vm.isSoftbank()) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.getContactUrl(),
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.pauseAudio()
      }
    }
  }, [_vm._v("お問い合わせ")])]) : _vm._e(), _vm._v(" "), (_vm.isAu() || _vm.isSoftbank()) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.getFaqUrl(),
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.pauseAudio()
      }
    }
  }, [_vm._v("FAQ")])]) : _vm._e(), _vm._v(" "), (_vm.isSoftbank()) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.showPrivacyPolicy()
      }
    }
  }, [_vm._v("プライバシーポリシー")]) : _vm._e(), _vm._v(" "), (_vm.isAu()) ? _c('li', [_c('a', {
    attrs: {
      "href": "http://www.sourcenext.com/r/p/au/rosetta_us/product/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.pauseAudio()
      }
    }
  }, [_vm._v("製品紹介")])]) : _vm._e()]), _vm._v(" "), (_vm.showHintArea) ? _c('div', {
    staticClass: "hintArea"
  }, [_c('div', [_vm._v(_vm._s(_vm.hintText))])]) : _vm._e()])])], 1)])])]), _vm._v(" "), (_vm.isLogoutVisible) ? _c('Logout', {
    attrs: {
      "productInfo": _vm.productInfo
    },
    on: {
      "closeLogout": function($event) {
        return _vm.closeLogout()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isTakeOverVisible) ? _c('TakeOver', {
    on: {
      "close": function($event) {
        return _vm.closeTakeOver()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-dic",
    staticStyle: {
      "cursor": "default"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/header/icon_dic.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9925b318", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-9925b318","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 882
// module chunks = 1